export const ROLES = [
  'Stylist',
  'Barber',
  'Colorist',
  'Nail Tech',
  'Esthetician',
  'Massage Therapist',
  'Bartender',
  'Barback',
  'Server',
  'Busser',
  'Host',
  'Dishwasher',
  'Front Desk',
  'Receptionist',
  'Shift Lead',
  'Store Manager',
  'General Manager',
  'Regional Manager',
  'Area Manager',
  'Salon Manager',
  'Manager',
  'Owner'
];

// Roles eligible for shared employee tip pools under federal FLSA regulations.
// (Managers/owners retain 100% of direct tips and solo shift tips, but are excluded from shared staff pools)
export const ELIGIBLE_ALLOCATION_ROLES = [
  'Stylist',
  'Barber',
  'Colorist',
  'Nail Tech',
  'Esthetician',
  'Massage Therapist',
  'Bartender',
  'Barback',
  'Server',
  'Busser',
  'Host',
  'Dishwasher',
  'Front Desk',
  'Receptionist'
];

// Helper to identify supervisory/managerial roles excluded from shared employee tip pools per FLSA regulations
export const isManagerialRole = (role: string): boolean => {
  return /manager|owner|supervisor|lead|director|general manager|regional manager|area manager|exec/i.test(role);
};
